import { render, staticRenderFns } from "./TakipList.vue?vue&type=template&id=3e01e944&scoped=true"
import script from "./TakipList.vue?vue&type=script&lang=ts"
export * from "./TakipList.vue?vue&type=script&lang=ts"
import style0 from "./TakipList.vue?vue&type=style&index=0&id=3e01e944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e01e944",
  null
  
)

export default component.exports